import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

import LinearProgress from "@material-ui/core/LinearProgress";
import { TextField, Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';


import Button from "@material-ui/core/Button";
import CustomizedSnackbar from "./CustomizedSnackbar";
import backgroundcolor from "./images/headphones.jpg";


const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: "#34495E",
    color: "#fff"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  grid: {
    alignContent: "center",
    alignItems: "center",
    display: "inline-block",
    width: 350
  },
  paper: {
    backgroundImage: `url(${backgroundcolor})`,
    backgroundSize: "cover",
    height: "650px"
  },
  bar: {
    marginTop: 5
  },
  heading: {
    fontFamily: "Helvetica",
    fontWeight: "bold"
  },
  centered: {
    marginTop:20,
    alignContent: "center",
    alignItems: "center",
    display: "inline-block",
    width: 450
  },
  appBar:{
    background:"Black",
    elevation:0
  },
}));

export default function UploadFiles(props) {
  const classes = useStyles();

  const [uploadStatus, setuploadStatus] = useState("");
  const [progress, setProgress] = useState(0);

  const [snackbarMessage, setsnackbarMessage] = useState();
  const [snackbarVariant, setsnackbarVariant] = useState();
  const [snackbarTrigger, setsnackbarTrigger] = useState();

  const [artist, setArtist] = useState("");
  const [songName, setSongname] = useState("");
  const [audio, setAudio] = useState();
  const [cover, setCover] = useState();
  const [songDescription, setSongDescription] = useState("");





  const uploadData = () => {
    var links = [];

    if (artist && songName && cover && songDescription) {
      const file = cover[0];
      const CstorageRef = firebase.storage().ref("SongCovers/");
      const mainImage = CstorageRef.child(cover[0].name);
      mainImage.put(file).then(snapshot => {
        mainImage.getDownloadURL().then(url => {
          links.push(url);
        });
      });

      var song = audio[0];
      var metadata = {
        contentType: "audio/mpeg"
      };
      const storageRef = firebase
        .storage()
        .ref("Audios/")
        .child(song.name)
        .put(song, metadata);

      storageRef.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              setuploadStatus("Your song is uploading,please wait.");
              break;
            default:
            // do nothing
          }
        },
        function(error) {
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
            case "storage/unknown":
              break;
            default:
            // do nothing
          }
        },
        function() {
          storageRef.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            if (downloadURL) {
              firebase
                .firestore()
                .collection("DownloadUrls")
                .add({
                  Url: links[0],
                  SongName: songName,
                  Artist: artist,
                  Song: downloadURL,
                  Description: songDescription
                })
                .then(() => {
                  setTimeout(() => {
                    setSongname("");
                    setArtist("");
                    triggerSnackbar("File successfully uploaded", "success");
                    setProgress(0);
                    GOBACK();
                  }, 1000);
                })
                .catch(error => {
                  triggerSnackbar("Failed to upload file", "error");
                });
            } else {
              triggerSnackbar("All fields must be filled.", "error");
            }
          });
        }
      );
    }
  };

  const triggerSnackbar = (message, variant) => {
    setsnackbarMessage(message);
    setsnackbarVariant(variant);
    setsnackbarTrigger(true);
  };

  const onSnackbarClose = () => {
    setsnackbarTrigger(false);
  };

  const logout=e=>{
    firebase.auth().signOut().then(function() {
      window.location.href = "/";
    }).catch(function(error) {
      triggerSnackbar("Error logging out", "error");
    });

  }

  const onfileChange = e => {
    const files = e.target.files;
    if (files.length > 0) {
      setCover(files);
    }
  };

  const onAudiofileChange = e => {
    const files = e.target.files;
    setAudio(files);
  };

  const GOBACK = () => {
    props.history.push("/");
  };
  return (
    <React.Fragment>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            K-BRIELLY MUSIC
          </Typography>
        </Toolbar>
      </AppBar>
        <CustomizedSnackbar
          message={snackbarMessage}
          trigger={snackbarTrigger}
          variant={snackbarVariant}
          onClose={onSnackbarClose}
        />
        <div className={classes.grow}>
          <Paper className={classes.paper}>
          <Paper className={classes.centered}>
            <Grid className={classes.grid}>
            
              <Grid className={classes.bar}>
                {progress ? (
                  <LinearProgress variant="determinate" value={progress} />
                ) : null}
              </Grid>
              <Grid style={{ display: "flex-start" }}>
                <Typography className={classes.heading}>Song Upload</Typography>
                <Typography>
                  {uploadStatus}
                  {progress ? Math.round(progress) + " %" : null}
                </Typography>
              </Grid>
              <TextField
                id="outlined-full-width"
                label="Artist Name"
                placeholder="K-Brielly"
                style={{ margin: 8 }}
                fullWidth
                margin="normal"
                variant="outlined"
                required
                value={artist}
                onChange={e => {
                  let name = e.target.value;
                  setArtist(name);
                }}
              />
              <TextField
                id="outlined-email-input"
                label="Song name"
                placeholder="Broken Soul"
                className={classes.textField}
                type="text"
                name="song"
                margin="normal"
                variant="outlined"
                fullWidth
                required
                value={songName}
                onChange={e => {
                  let song = e.target.value;
                  setSongname(song);
                }}
              />
              <Typography>Song Cover</Typography>
              <input
                id="cover"
                className={classes.textField}
                name="cover"
                type="file"
                accept="image/*"
                required
                
                style={{ width: 350, height: 50, border: "2px solid black" }}
                onChange={onfileChange}
              />
              <Typography>Select a song to upload (Only mp3/wav)</Typography>
              <input
                id="audio"
                accept="audio/*"
                className={classes.textField}
                type="file"
                required
                
                onChange={onAudiofileChange}
                style={{ width: 350, height: 50, border: "2px solid black" }}
              />
              <TextField
                id="outlined-multiline-static"
                label="Song Description"
                multiline
                rows="4"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                fullWidth
                valu={songDescription}
                onChange={e => {
                  let song = e.target.value;
                  setSongDescription(song);
                }}
              />
              <Button
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={uploadData}
              >
                upload
              </Button>
              <Button
                type="submit"
                variant="contained"
                onClick={logout}
                style={{
                  backgroundColor: "#030832",
                  color: "#FFF",
                  position: "relative"
                }}
              >
                Sign Out
              </Button>
              
            </Grid>
            </Paper>
          </Paper>
        </div>
     
    </React.Fragment>
  );
}
